export const career = [
  [
    '2026 — Present',
    'Specialist in Endocrinology & Metabolic Diseases',
    'Mardin Training and Research Hospital',
    'Mardin, Türkiye',
  ],
  [
    '2022 — 2026',
    'Endocrinology & Metabolic Diseases',
    'Ankara Bilkent City Hospital',
    'Ankara, Türkiye',
  ],
  ['2020 — 2021', 'Specialist in Internal Medicine', 'Hüyük State Hospital', 'Konya, Türkiye'],
  [
    '2015 — 2020',
    'Research Assistant · Internal Medicine',
    'Hacettepe University Faculty of Medicine',
    'Ankara, Türkiye',
  ],
  [
    '2013 — 2014',
    'Research Assistant · Pediatrics',
    'Ankara University Faculty of Medicine',
    'Ankara, Türkiye',
  ],
];

export const courses = [
  [
    'Data science & programming',
    [
      'Python for Everybody Specialization · University of Michigan, Coursera',
      'Applied Data Science with Python Specialization · University of Michigan, Coursera',
      'IBM Data Science Professional Certificate · Coursera',
      'Machine Learning Specialization · DeepLearning.AI',
    ],
  ],
  [
    'Endocrinology',
    [
      'Endocrine Board Review 2023 Bundle · Completed December 2024; 55 AMA PRA Category 1 Credits™; practice exam 93% (non-board)',
      'Update in Primary Aldosteronism · January 2025',
      'Artificial Intelligence in Endocrine Diseases · November 2024',
    ],
  ],
  [
    'Biostatistics',
    [
      'Basic Biostatistics Course for Health Research · Prof. Dr. Mutlu Hayran, Hacettepe University, 2017',
    ],
  ],
];

export const memberships = [
  ['Society of Endocrinology and Metabolism of Türkiye', 'TEMD · Since 2024'],
  ['European Society of Endocrinology', 'ESE · Since 2024'],
  ['Endocrine Society', 'Since 2024'],
  ['The Obesity Society', 'TOS · Since 2025'],
];

export const languages = [
  ['English', 'IELTS Academic 6.5 · January 2026', 'YDS 81.25 · November 2025'],
  ['Swedish', 'B2 · February 2026'],
  ['French', 'B1 · 2025'],
  ['German', 'A2 · 2025'],
];

export const cvUrl = `${process.env.PUBLIC_URL}/documents/riza-gokhan-baykal-cv.docx`;
